import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CheckmarkOutlinedIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" strokeWidth={1.5} {...props}>
            <path
                d="M18 9.26858V10.0046C17.999 11.7297 17.4404 13.4083 16.4075 14.79C15.3745 16.1718 13.9226 17.1826 12.2683 17.6717C10.6139 18.1608 8.84581 18.1021 7.22757 17.5042C5.60934 16.9064 4.22772 15.8015 3.28877 14.3542C2.34981 12.907 1.90383 11.195 2.01734 9.47363C2.13085 7.75223 2.79777 6.11364 3.91862 4.80224C5.03948 3.49083 6.55423 2.57688 8.23695 2.1967C9.91967 1.81651 11.6802 1.99045 13.256 2.69258"
                stroke="currentColor"
                fill="none"
                strokeWidth="inherit"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18 4L9.42809 13L7 10.1607"
                stroke="currentColor"
                fill="none"
                strokeWidth="inherit"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
